import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import AlarmIcon from '@material-ui/icons/Alarm';
import VerifiedUser from "@material-ui/icons/VerifiedUser";
import EmojiTransportationIcon from '@material-ui/icons/EmojiTransportation';
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import InfoArea from "components/InfoArea/InfoArea.js";
import styles from "assets/jss/material-kit-react/views/landingPageSections/productStyle.js";

const useStyles = makeStyles(styles);

export default function ProductSection() {
  const classes = useStyles();
  return (
    <div className={classes.section}>
      <GridContainer justify="center">
        <GridItem xs={12} sm={12} md={8}>
          <h2 className={classes.title}>Service Information</h2>
          <h5 className={classes.description}>
          Treat yourself with top of the class ridesharing experience with GG Ridesharing. We provide services in the USA and we are proud to introduce to you an affordable & reliable ridesharing app. If you find yourself often late for work, meeting, a date, or you just feel lazy, do not hesitate. GG drivers are always around the corner.
          </h5>
        </GridItem>
      </GridContainer>
      <div>
        <GridContainer>
        <GridItem xs={12} sm={12} md={4}>
            <InfoArea
              title="Your Personal Ride"
              description="Tell us about your day, we will make it better with just a ride."
              icon={EmojiTransportationIcon}
              iconColor="danger"
              vertical
            />
          </GridItem>
          <GridItem xs={12} sm={12} md={4}>
            <InfoArea
              title="24 Hrs Service"
              description="No more stranded, hit the button at anytime to request a ride."
              icon={AlarmIcon}
              iconColor="info"
              vertical
            />
          </GridItem>
          <GridItem xs={12} sm={12} md={4}>
            <InfoArea
              title="Highly Secured"
              description="We keep the app safe by provide timely security updates."
              icon={VerifiedUser}
              iconColor="success"
              vertical
            />
          </GridItem>
        </GridContainer>
        <GridContainer className={classes.textCenter} justify="center">
          <GridItem xs={12} sm={12} md={8}>
            <h2 className={classes.title}>Mobile Apps available on App Stores</h2>
            <img className={classes.triobanner} src={"https://www.codemade.io/wp-content/uploads/2019/08/uber-clone-uber-clone-app-uber-like-app-development-appdupe-1565071026ng4k8.png"} alt="GG App Banner" />
            <h4 className={classes.description}>Now our apps are available in the app stores. Go download them now</h4>
          </GridItem>
          <GridItem xs={12} sm={8} md={6}>
            <a href="https://apps.apple.com/"><img src="https://dev.exicube.com/images/appstore.png" alt="GG Apple Store Link"/></a>
            <span style={{marginRight: '5px'}}></span>
            <a href="https://play.google.com/"><img src="https://dev.exicube.com/images/playstore.png" alt="GG Playstore Link"/></a>
          </GridItem>
        </GridContainer>
      </div>
    </div>
  );
}
